import {
  calculateMissionScoreBreakdown,
  getMissionRank,
} from './rangerLogic';

export function createMissionCompletePayload({
  level,
  levelIndex,
  selectedClassId = 'ranger',
  elapsedMs,
  alertCount = 0,
  enemyDefeatCount = 0,
  remainingLives = 0,
}) {
  const scoreBreakdown = calculateMissionScoreBreakdown({
    elapsedMs,
    alertCount,
    enemyDefeatCount,
    remainingLives,
  });
  const rank = getMissionRank({
    score: scoreBreakdown.score,
    elapsedMs,
    alertCount,
    remainingLives,
  });

  return {
    levelIndex,
    missionId: level?.id,
    score: scoreBreakdown.score,
    scoreBreakdown,
    rank,
    elapsedMs,
    alertCount,
    enemyDefeatCount,
    remainingLives,
    selectedClassId,
  };
}
